"use strict";
import CarrierInvoicesStore from "../stores/carrier_invoices_store";
var CarrierInvoicesService = function() {
  this._store = CarrierInvoicesStore;
  this.processedInvoices = function() {
    return _.sortBy(
      _.where(this._store.items, { state: "processed" }),
      (invoice) => {
        return /* @__PURE__ */ new Date() - new Date(invoice.processed_at);
      }
    );
  };
  this.getInvoiceById = function(invoiceId) {
    return this._store.find(invoiceId);
  };
  this.startObservingUpdates = function(handler) {
    $(this).on("carrier_invoices_service:updated", handler);
  }.bind(this);
  this.stopObservingUpdates = function(handler) {
    $(this).off("carrier_invoices_service:updated", handler);
  }.bind(this);
};
var carrierInvoicesService = new CarrierInvoicesService();
export default carrierInvoicesService;
